import Components from "../components";
import FaultSearch from "./fault_search/fault_search";
import { defaultZone, zoneToOffset } from "../time_helpers";

class NoticeSearch extends FaultSearch {
  bind() {
    super.bind();
    this.on("submit", (e) => this.onSubmit(e));
    this.on("click", ".search-reset", (e) => this.onResetSearch(e));
    this.on(
      $(document),
      "notice-timeline-selection",
      this.onTimelineSelection.bind(this),
    );
  }

  onTimelineSelection(e) {
    const d = e.detail;
    const token = this.query.tokens.find((t) => t.text.startsWith("occurred"));
    const range = `[${this.formatDate(d.start)} TO ${this.formatDate(d.end)}]`;
    const text = `occurred:"${range}"`;
    if (token) {
      this.query.replaceToken(token.cloneWithNewText(text));
    } else {
      this.query.prepend(text);
    }

    this.triggerSearch();
    this.query.select(null);
    this.hideHint();
  }

  formatDate(d) {
    const offsetZone = defaultZone();
    const offset = zoneToOffset(offsetZone);
    return d.utcOffset(offset).format(`YYYY-MM-DD H:mm ${offsetZone}`);
  }

  onSubmit() {
    this.hideHint();
  }

  onResetSearch(e) {
    this.query.update("", 0, 0);
    this.$input.val("");

    this.triggerSearch();
    e.preventDefault();
    e.stopPropagation();
  }

  triggerSearch() {
    this.$form[0].requestSubmit();
  }
}

Components.collection.register({
  selector: ".c-notice-search",
  klass: NoticeSearch,
});
